// src/services/localStorageService.js

const localStorageService = {
    // Use this method to make authenticated GET requests
    get(item) {
        return localStorage.getItem(item);
    },

    set(item, data) {
        return localStorage.setItem(item, data);
    }
};

export default localStorageService;
